import React, { useEffect, useState } from 'react';
import { apiFetch } from '../api';
import WorldChoropleth from './WorldChoropleth';

export default function GeoAnalytics({ path }) {
  const [geo, setGeo] = useState(null);
  const [allOpen, setAllOpen] = useState({ countries: false, cities: false });
  const [allData, setAllData] = useState(null);
  const [err, setErr] = useState('');

  const loadTop = async () => {
    setErr('');
    try {
      const qs = new URLSearchParams();
      if (path) qs.set('path', path);
      const res = await apiFetch(`stats_geo.php?${qs.toString()}`);
      const js  = await res.json();
      if (js.error) throw new Error(js.message || 'Serverfehler');
      setGeo(js);
    } catch {
      setErr('Konnte Geo-Daten nicht laden.');
    }
  };

  const loadAll = async () => {
    if (allData) return;
    try {
      const qs = new URLSearchParams();
      if (path) qs.set('path', path);
      qs.set('all','1');
      const res = await apiFetch(`stats_geo.php?${qs.toString()}`);
      const js  = await res.json();
      if (js.error) throw new Error(js.message || 'Serverfehler');
      setAllData(js.all || { countries:[], cities:[] });
    } catch {}
  };

  useEffect(()=>{ loadTop(); }, [path]);

  return (
    <div className="card">
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
        <h3>Länder & Städte</h3>
        {path ? <span style={{opacity:.7}}>Filter: {path}</span> : null}
      </div>

      {err && <div style={{color:'crimson', marginBottom:8}}>{err}</div>}

      {/* Karte + Top-Listen nebeneinander */}
      <div style={{display:'grid', gridTemplateColumns:'minmax(320px, 1fr) 380px', gap:'1rem', alignItems:'start'}}>
        <div className="card" style={{padding:'0.5rem'}}>
          <h4 style={{margin:'0.25rem 0 0.5rem'}}>Weltkarte (Pageviews)</h4>
          <WorldChoropleth data={geo?.choropleth || []} />
        </div>

        <div style={{display:'grid', gap:'1rem'}}>
          {/* Top Länder */}
          <div className="card">
            <h4>Top Länder</h4>
            <table style={{width:'100%'}}>
              <thead><tr><th style={{textAlign:'left'}}>Land</th><th style={{textAlign:'right'}}>Views</th></tr></thead>
              <tbody>
                {(geo?.top?.countries || []).map(row=>(
                  <tr key={row.code}>
                    <td>{row.name || row.code}</td>
                    <td style={{textAlign:'right', fontVariantNumeric:'tabular-nums'}}>{row.views}</td>
                  </tr>
                ))}
                {(!geo || (geo.top?.countries||[]).length===0) && <tr><td colSpan="2" style={{opacity:.7}}>Keine Daten</td></tr>}
              </tbody>
            </table>
            <button className="secondary" style={{marginTop:8}}
              onClick={()=>{ setAllOpen(s=>({...s, countries:!s.countries})); if(!allData) loadAll(); }}>
              {allOpen.countries ? 'Weniger' : 'Alle anzeigen'}
            </button>
            {allOpen.countries && (
              <div style={{maxHeight:220, overflow:'auto', marginTop:8}}>
                <table style={{width:'100%'}}>
                  <tbody>
                    {(allData?.countries||[]).map(r=>(
                      <tr key={r.country_code}>
                        <td>{r.country_name || r.country_code}</td>
                        <td style={{textAlign:'right'}}>{r.views}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Top Städte */}
          <div className="card">
            <h4>Top Städte</h4>
            <table style={{width:'100%'}}>
              <thead><tr><th style={{textAlign:'left'}}>Stadt</th><th style={{textAlign:'right'}}>Views</th></tr></thead>
              <tbody>
                {(geo?.top?.cities || []).map((row,i)=>(
                  <tr key={i}>
                    <td>{row.city}{row.code ? ` (${row.code})` : ''}</td>
                    <td style={{textAlign:'right', fontVariantNumeric:'tabular-nums'}}>{row.views}</td>
                  </tr>
                ))}
                {(!geo || (geo.top?.cities||[]).length===0) && <tr><td colSpan="2" style={{opacity:.7}}>Keine Daten</td></tr>}
              </tbody>
            </table>
            <button className="secondary" style={{marginTop:8}}
              onClick={()=>{ setAllOpen(s=>({...s, cities:!s.cities})); if(!allData) loadAll(); }}>
              {allOpen.cities ? 'Weniger' : 'Alle anzeigen'}
            </button>
            {allOpen.cities && (
              <div style={{maxHeight:220, overflow:'auto', marginTop:8}}>
                <table style={{width:'100%'}}>
                  <tbody>
                    {(allData?.cities||[]).map((r,i)=>(
                      <tr key={i}>
                        <td>{r.city}{r.country_code ? ` (${r.country_code})` : ''}</td>
                        <td style={{textAlign:'right'}}>{r.views}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
